export const filterPricingCards = () => {
  const filterButtons = document.querySelectorAll(".pricing-categories-btn");
  const pricingCards = document.querySelectorAll(".pricing-card");

  filterButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const category = btn.dataset.pricingFilter;

      filterButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      pricingCards.forEach((card) => {
        if (category === "all" || card.dataset.pricingCategory === category) {
          card.style.display = "block";
        } else {
          card.style.display = "none";
        }
      });
    });
  });
};
